import { render, staticRenderFns } from "./PaginationListModal.vue?vue&type=template&id=3737e981&scoped=true&lang=pug"
import script from "./PaginationListModal.vue?vue&type=script&lang=js"
export * from "./PaginationListModal.vue?vue&type=script&lang=js"
import style0 from "./PaginationListModal.vue?vue&type=style&index=0&id=3737e981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3737e981",
  null
  
)

export default component.exports